import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Phone, MapPin } from "lucide-react";
import { api } from "../lib/api";
import { formatPhone, telHref } from "../lib/format";
import { LogoMark } from "./Logo";

export const Footer = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
  <footer className="bg-forest-deep text-white relative overflow-hidden grain">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 lg:py-24 relative z-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <LogoMark className="w-10 h-10" />
            <span className="font-display font-extrabold text-xl tracking-tight">GLOW<span className="text-leaf"> GREEN</span></span>
          </div>
          <p className="mt-5 text-white/70 text-sm leading-relaxed max-w-sm">
            A brighter clean. A better value. Premium commercial and residential cleaning for St. Louis, Chesterfield, and surrounding Missouri communities.
          </p>
        </div>
        <div className="md:col-span-3">
          <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-leaf">Services</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/commercial-cleaning" data-testid="footer-commercial-link" className="text-white/75 hover:text-leaf transition-colors">Commercial Cleaning</Link></li>
            <li><Link to="/residential-cleaning" data-testid="footer-residential-link" className="text-white/75 hover:text-leaf transition-colors">Residential Cleaning</Link></li>
            <li><Link to="/residential-cleaning" data-testid="footer-deep-link" className="text-white/75 hover:text-leaf transition-colors">Deep Cleaning</Link></li>
            <li><Link to="/residential-cleaning" data-testid="footer-move-link" className="text-white/75 hover:text-leaf transition-colors">Move-In / Move-Out</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-leaf">Company</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/about" data-testid="footer-about-link" className="text-white/75 hover:text-leaf transition-colors">About</Link></li>
            <li><Link to="/service-areas" data-testid="footer-areas-link" className="text-white/75 hover:text-leaf transition-colors">Service Areas</Link></li>
            <li><Link to="/blog" data-testid="footer-blog-link" className="text-white/75 hover:text-leaf transition-colors">Blog</Link></li>
            <li><Link to="/contact" data-testid="footer-contact-link" className="text-white/75 hover:text-leaf transition-colors">Contact</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-leaf">Get Started</h3>
          <Link
            to="/contact"
            data-testid="footer-quote-button"
            className="mt-4 inline-flex items-center rounded-full bg-leaf px-5 py-2.5 text-sm font-semibold text-forest-deep transition-all hover:bg-mint hover:scale-[1.03]"
          >
            Free Quote
          </Link>
          {settings?.phone && (
            <p className="mt-4 flex items-center gap-2 text-white/75 text-xs">
              <Phone className="w-3.5 h-3.5 text-leaf flex-shrink-0" />
              <a href={telHref(settings.phone)} data-testid="footer-phone-link" className="hover:text-leaf transition-colors">{formatPhone(settings.phone)}</a>
            </p>
          )}
          {settings?.address && (
            <p className="mt-2 flex items-center gap-2 text-white/50 text-xs" data-testid="footer-address">
              <MapPin className="w-3.5 h-3.5 text-leaf flex-shrink-0" /> {settings.address}
            </p>
          )}
          {!settings?.phone && !settings?.address && (
            <p className="mt-4 text-white/50 text-xs leading-relaxed">Serving the greater St. Louis area.</p>
          )}
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="text-white/40 text-xs">© {new Date().getFullYear()} Glow Green. All rights reserved.</p>
        <Link to="/admin/login" data-testid="footer-admin-link" className="text-white/30 hover:text-white/60 text-xs transition-colors">Owner Login</Link>
      </div>
    </div>
    <div className="pointer-events-none select-none absolute -bottom-10 left-0 right-0 text-center font-display font-extrabold text-[18vw] leading-none text-white/[0.03] tracking-tighter" aria-hidden="true">
      GLOW
    </div>
  </footer>
  );
};
